import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  CardTitle,
  Form,
  Container,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Label,
  Row
} from "reactstrap";

import { Link } from "react-router-dom";

import axios from "axios";

import { Button } from "components";

import nowLogo from "assets/img/nadu-logo-full.png";

import bgImage1 from "assets/img/minibg/bg1.jpg";
import bgImage2 from "assets/img/minibg/bg2.jpg";
import bgImage3 from "assets/img/minibg/bg3.jpg";
import bgImage4 from "assets/img/minibg/bg4.jpg";
import bgImage5 from "assets/img/minibg/bg5.jpg";
import bgImage6 from "assets/img/minibg/bg6.jpg";
import bgImage7 from "assets/img/minibg/bg7.jpg";
import bgImage8 from "assets/img/minibg/bg8.jpg";
import bgImage9 from "assets/img/minibg/bg9.jpg";
import bgImage10 from "assets/img/minibg/bg10.jpg";
import bgImage11 from "assets/img/minibg/bg11.jpg";
import bgImage12 from "assets/img/minibg/bg12.jpg";
import { faLastfmSquare, faSellsy } from "@fortawesome/free-brands-svg-icons";
import { validateSpanishId } from "spain-id";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SweetAlert from "react-bootstrap-sweetalert";

// const API = "https://mi.nadunet.es/api/rest/";
const START_RECHARGE = "nadunet_tpv_resources/start_recharge";
const DEBUG_MODE = window.location.host.includes("localhost");
const API = DEBUG_MODE
  ? "https://mi.nadunet.es/api/rest/"
  : "https://" + window.location.host + "/api/rest/";
const bgs = [
  bgImage1,
  bgImage2,
  bgImage3,
  bgImage4,
  bgImage5,
  bgImage6,
  bgImage7,
  bgImage8,
  bgImage9,
  bgImage10,
  bgImage11,
  bgImage12
];
const recuperarPassStyle = {
  textAlign: "center"
};
const privacyStyle = {
  textAlign: "center",
  color: "#FFF",
  marginTop: "20px"
};
class Payment_OK extends React.Component {
  constructor(props) {
    super(props);
    let randomBgNumber = this.randomIntFromInterval(0, 11);
    let randomBg = bgs[randomBgNumber];

    let okPopUp = (
      <SweetAlert
        success
        style={{ display: "block", marginTop: "-150px" }}
        title="Pago completado"
        onConfirm={() => this.redirectTo("/entrar")}
        // onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        // cancelBtnBsStyle="default"
        confirmBtnText="Aceptar"
        // cancelBtnText="Cancelar"
        // showCancel
      />
    );

    this.state = {
      randomBg: randomBg,
      popUp: okPopUp
    };

    this.startPayment = this.startPayment.bind(this);
    this.showError = this.showError.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
  }
  componentDidUpdate(prevProps, prevState) {
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  randomIntFromInterval(min,max) {
      return Math.floor(Math.random()*(max-min+1)+min);
  }
  startPayment() {
    let state = this.state;
    state.isStartingPayment = true;
    this.setState(state);

    let request = {
      input: {
        dni: this.state.dni,
        amount: this.state.amount
      }
    };

    axios.post(API + START_RECHARGE, request, {withCredentials: false})
      .then(result => {
        /* ////// console.log("################## RESPUESTA ################");
        ////// console.log(result); */
        let response = result.data;
        if (response.result === "OK") {
          let state = this.state;
          state.paymentForm = 
            <div
              ref = { this.paymentFormButton }
              style={{ display: "none" }}
              dangerouslySetInnerHTML={{
                __html: response.form
              }}
            />;
          this.setState(state);
          state.buttonReference = this.paymentFormButton.current.children[0].children[3];
          state.popUp = (
            <SweetAlert
              style={{ display: "block", marginTop: "-150px" }}
              title="Proceso de pago"
              onConfirm={() => this.redirectToPayment()}
              // onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="primary"
              // cancelBtnBsStyle="default"
              confirmBtnText="Aceptar"
              // cancelBtnText="Cancelar"
              // showCancel
            >
              <Row>
                <Col xs={3}>
                  <div>
                    <FontAwesomeIcon icon={['far', 'credit-card']} size="3x" />
                  </div>
                </Col>
                <Col xs={9} className="text-left">
                  <span>Ahora, te vamos a redirigir a la pasarela de pago de tu banco para que lo realices con tu tarjeta</span>
                </Col>
              </Row>
            </SweetAlert>
          );
          this.setState(state);
        } else {
          this.showError(response.error);
        }
      })
      .catch((error) => {
        // Error 😨
        this.setState({
          isStartingPayment: false
        });
        this.showError("Error al iniciar el proceso, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  validateForm() {
    console.log("validate form:", this.state);
    let result = true;
    if (!this.validateDNI(this.state.dni)) return false;
    if (!this.validateAmount(this.state.amount)) return false;

    return result;
  }
  validateDNI(value) {
    if (!value) return false;

    var regPassport = /^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$/;
    var validPassport = regPassport.test(value);
    if (validateSpanishId(value) || validPassport) {
      return true;
    } else {
      return false;
    }
  }
  validateAmount(value) {
    if (!value) return false;
    value = parseFloat(value);
    return value >= 5;
  }
  getFormButton() {
    let button = null;

    if (this.state.isStartingPayment){
      button = (
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>
      );
    } else {
      button = "Recargar";
    }

    return button;
  }
  handleChange(field, event) {
    //////// console.log("Field name: " + field);
    //////// console.log("Field value: " + event.target.value);
    this.setState({ [field]: event.target.value });
  }
  showError(error) {
    var options = {
      place: "tr",
      message: error,
      type: "danger",
      icon: "now-ui-icons objects_key-25",
      autoDismiss: 3
    };
    this.props.showNotification(options);
  }
  redirectToPayment() {
    this.state.buttonReference.click();
    this.setState({
      alreadyRedirected: true,
      popUp: null,
      dni: "",
      amount: 0
    });
  }
  render() {
    return (
      <div>
        <div className="full-page-content">
          {this.state.paymentForm}
          {this.state.popUp}
          <div className="login-page">
            <Container>
              <Col xs={12} md={8} lg={4} className="ml-auto mr-auto">
                <Form>
                  <Card className="card-login card-plain">
                    <CardHeader>
                      <div className="logo-container">
                        <img src={nowLogo} alt="nadunet" />
                      </div>
                      <CardTitle className="text-center">
                        <span>Recarga de saldo</span>
                      </CardTitle>
                    </CardHeader>
                    <CardBody>
                      <InputGroup
                        className={
                          "no-border form-control-lg " +
                          (this.state.dniFocus ? "input-group-focus" : "")
                        }
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons users_circle-08" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          placeholder="DNI"
                          onFocus={e => this.setState({ dniFocus: true })}
                          onBlur={e => this.setState({ dniFocus: false })}
                          value={this.state.dni}
                          onChange={(e) => this.handleChange("dni", e)}
                          disabled={this.state.isStartingPayment}
                        />
                      </InputGroup>
                      <InputGroup
                        className={
                          "no-border form-control-lg " +
                          (this.state.amountFocus ? "input-group-focus" : "")
                        }
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons objects_key-25" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="number"
                          placeholder="Importe"
                          onFocus={e => this.setState({ amountFocus: true })}
                          onBlur={e => this.setState({ amountFocus: false })}
                          value={this.state.amount}
                          onChange={(e) => this.handleChange("amount", e)}
                          disabled={this.state.isStartingPayment}
                        />
                      </InputGroup>
                    </CardBody>
                    <CardFooter>
                      <Button
                        block
                        round
                        disabled={this.state.isStartingPayment || !this.validateForm()}
                        color={this.state.isStartingPayment ? "default" : "primary"}
                        size="lg"
                        href=""
                        className="mb-3"
                        onClick={this.startPayment}
                      >
                        {this.getFormButton()}
                      </Button>
                      <div style={privacyStyle}>
                        <a style={privacyStyle} target="_blank" href="https://nadunet.es/politica-privacidad">Política de privacidad</a>
                      </div>
                      {/* this.state.loginError && loginErrorMessage */}
                      {/* <div className="pull-right">
                        <h6>
                          <a href="#pablo" className="link footer-link">
                            Need Help?
                          </a>
                        </h6>
                      </div> */}
                    </CardFooter>
                  </Card>
                </Form>
              </Col>
            </Container>
          </div>
        </div>
        <div
          className="full-page-background"
          style={{ backgroundImage: "url(" + this.state.randomBg + ")" }}
        />
      </div>
    );
  }
}

export default Payment_OK;



// WEBPACK FOOTER //
// ./src/views/Pages/Payment_OK.jsx